import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment/moment';
import { formatHours, PermissionList, RolePermission, Images, FindLoad, apptIssueType, useModal } from 'utils';
import { DetailItem, DateRow, LinkRow, MinLoader, CustomDelete, SimpleTooltip, LocalDateRow, NonBillable } from 'components';
import { appointmentActions, systemActions } from 'store';
import { billStatuses, scheduleStatuses, SERVICE } from '../../../constants';
import { roundUnitEnums } from './constants';
import { Eligibility } from '../../common';
import { serviceTypeEnum } from '../constants';

const upDownActionType = 'CHANGE_APPT_UNITS';
const checkEligibility = 'CHECK_ELIGIBILITY';
export const ServiceItems = ({ item }) => {
    const canUseIntegrations = useSelector((state) => state.system.canUseIntegrations);
    const dispatch = useDispatch();
    const loader = FindLoad(upDownActionType);
    const loadEligibility = FindLoad(checkEligibility);
    const incompleteUnits = item?.issues?.find((i) => i.issueType === apptIssueType.INCOMPLETE_UNITS);
    const { open } = useModal();

    const canViewAuthorization = RolePermission([
        PermissionList.CLIENT_AUTHORIZATION_READ?.code,
        PermissionList.CLIENT_AUTHORIZATION_MANAGE?.code,
    ]);
    const canViewEnrollment = RolePermission([
        PermissionList.CLIENT_ENROLLMENT_READ?.code,
        PermissionList.CLIENT_ENROLLMENT_MANAGE?.code,
    ]);

    useEffect(() => {
        if (RolePermission([PermissionList.ELIGIBILITY_CHECK?.code])) {
            dispatch(systemActions.canUseIntegration());
        }
    }, []);

    const handleClick = (name) => {
        if (name === roundUnitEnums.ROUND_UP || name === roundUnitEnums.ROUND_DOWN) {
            open(
                <CustomDelete
                    info={'Confirm Rounding'}
                    text={`You're about to round the units ${name === roundUnitEnums.ROUND_UP ? 'up' : 'down'} to match the actual time. Do you want to continue?`}
                    innerText={'Confirm'}
                    color={'blue'}
                    handleDel={() => dispatch(appointmentActions.changeApptUnits(item.id, name))}
                    actionType={upDownActionType}
                />
            );
        }
    };

    const revertUnit = () => {
        open(
            <CustomDelete
                info={'Revert Units Rounding'}
                text={`You're about to revert the rounded units back to their originally calculated time. Do you want to continue?`}
                innerText={'Revert Units'}
                color={'blue'}
                handleDel={() => dispatch(appointmentActions.changeApptUnits(item.id, roundUnitEnums.ROUND_REVERT))}
                // handleDel={() => dispatch(appointmentActions.revertApptUnits(item.id))}
                actionType={upDownActionType}
            />
        );
    };

    const handleCheckEligibility = () => {
        dispatch(appointmentActions.checkEligibility(item?.client?.id, item?.id));
    };

    const serviceAppt = [
        canViewAuthorization && {
            title: 'Authorization',
            value: (
                <div className="space-between" style={{ gap: 8 }}>
                    <p>{`${item?.authorizedService?.authorizationId}, ${moment
                        .utc(item?.authorizedService?.startDate)
                        .format('MM/DD/YYYY')} - ${moment.utc(item?.authorizedService?.endDate).format('MM/DD/YYYY')}`}</p>
                    {item?.authorizedService?.billable === false && (
                        <NonBillable noIcon={true} style={{ fontSize: 12 }} wrapperStyles={{ height: 19 }} />
                    )}
                </div>
            ),
        },
        {
            title: 'Staff Paycode',
            value: item?.payCodeTypeName ? `${item.payCodeTypeName} ${item?.payCodeTypeCode ? `(${item?.payCodeTypeCode})` : ''}` : null,
        },
        canViewEnrollment && {
            title: 'Payer',
            value: item?.payerName ? (
                <LinkRow
                    name={item?.payerName ? `${item.payerName} ${item?.payerShortName ? `(${item?.payerShortName})` : ''}` : '--'}
                    href={RolePermission([PermissionList.FS_READ.code]) ? `/fundingSource/${item?.payerId}` : ''}
                    checkPermission={item?.payerId ? RolePermission([PermissionList.FS_READ.code]) : null}
                />
            ) : null,
        },
        {
            title: 'Units',
            value: item?.units ? (
                <div className="space-between-align-center">
                    <div className="flex-align-center" style={{ gap: 16, margin: '-1px 0' }}>
                        <div className="flex-align-center" style={{ gap: 4 }}>
                            <p>{item?.units?.toFixed(2)}</p>
                            {item.hours && <div className="option-service-units">{formatHours(item.hours)}</div>}
                        </div>
                        {incompleteUnits &&
                            (item?.exactUnits ? item?.exactUnits === item?.units : true) &&
                            item?.status === scheduleStatuses?.COMPLETED &&
                            // item?.status === scheduleStatuses?.PENDING ||
                            item?.billStatus !== billStatuses.BILLED && (
                                <div className="flex-align-center arrow-up-down-btn" style={{ gap: 4 }}>
                                    <SimpleTooltip title={'Round unit up to the nearest whole number'} placement="top" arrow>
                                        <button disabled={loader?.length} onClick={() => handleClick(roundUnitEnums.ROUND_UP)}>
                                            <img src={Images.arrowUp} alt="arrowUp" />
                                        </button>
                                    </SimpleTooltip>

                                    <SimpleTooltip title={'Round unit down to the nearest whole number'} placement="top" arrow>
                                        <button disabled={loader?.length} onClick={() => handleClick(roundUnitEnums.ROUND_DOWN)}>
                                            <img src={Images.arrowDown} alt="arrowDown" />
                                        </button>
                                    </SimpleTooltip>
                                </div>
                            )}
                        {!incompleteUnits && item?.exactUnits && item?.exactUnits !== item?.units && (
                            <div className="exact-units-box" style={{ margin: '-1px 0' }}>
                                {item?.units > item?.exactUnits ? (
                                    <div className="rounded-up">
                                        <img src={Images.arrowUp} alt="" />
                                        <p>Rounded up</p>
                                    </div>
                                ) : (
                                    <div className="rounded-down">
                                        <img src={Images.arrowDown} alt="" />
                                        <p>Rounded down</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    {item?.exactUnits && item?.exactUnits !== item?.units && (
                        <SimpleTooltip title={'Revert to original unit value before rounding'} placement="top" arrow>
                            <button onClick={revertUnit} className="revert-btn" style={{ margin: '-2px 0' }}>
                                <img src={Images.revertIcon} alt="revertIcon" />
                                <p>Revert</p>
                            </button>
                        </SimpleTooltip>
                    )}
                </div>
            ) : (
                '--'
            ),
            backgroundColor: incompleteUnits ? 'rgb(252, 235, 231)' : 'rgba(242, 244, 248, 0.5)',
        },

        {
            title: 'Type',
            value: item?.type
                ? `${
                      item?.serviceType === serviceTypeEnum.DIRECT
                          ? 'Direct'
                          : item?.serviceType === serviceTypeEnum.INDIRECT
                          ? 'Indirect'
                          : ''
                  }
                 ${item?.telehealth ? '( Telehealth )' : ''}`
                : '--',
        },

        {
            title: 'Place of Service',
            value: `${item?.posName} ${item?.posModifier ? `(${item?.posModifier})` : ''}`,
        },

        {
            title: 'Address',
            value: item?.location?.formattedAddress ? (
                <span>
                    {item?.locationLabel?.trim() && <span style={{ fontWeight: 600 }}>{item.locationLabel.trim()} · </span>}
                    {item.location.formattedAddress}
                </span>
            ) : (
                '--'
            ),
        },

        {
            title: 'Created At',
            value:
                item?.creatorFullName && item?.createdDate ? (
                    <div className="flex-align-center" style={{ gap: 4 }}>
                        <p>{item?.creatorFullName ? `${item.creatorFullName} - ` : ''}</p>
                        {item?.createdDate ? (
                            // <DateRow date={item?.createdDate} />
                            <LocalDateRow date={item?.createdDate} />
                        ) : (
                            ''
                        )}
                    </div>
                ) : (
                    '--'
                ),
        },

        // {
        //     title: 'Location',
        //     value: item?.telehealth ? 'Telehealth' : item?.location?.formattedAddress ? item?.location?.formattedAddress : '--',
        // },

        canViewEnrollment &&
            canUseIntegrations?.activeOfficeAllySOAP &&
            item?.type === SERVICE && {
                // (canUseIntegrations?.activeSOAP && item?.type === SERVICE) &&
                title: 'Eligibility Status',
                value: (
                    <div className="space-between-align-center">
                        <div>
                            {item?.client?.eligibilityCheck ? (
                                <div className="flex-align-center" style={{ gap: 4 }}>
                                    <p>{`Eligible (Last checked: ${moment
                                        .utc(item?.eligibilityCheck?.requestedDate)
                                        .format('MMM DD, YYYY')})`}</p>
                                    <Eligibility info={item?.client} payerShortName={item?.payerShortName} payerName={item?.payerName} />
                                </div>
                            ) : (
                                'Not checked'
                            )}
                        </div>

                        {
                            // (!item?.client?.eligibilityCheck || !item?.client?.eligibilityCheck?.status) &&
                            RolePermission([PermissionList.ELIGIBILITY_CHECK?.code]) &&
                                // canUseIntegrations?.activeOfficeAllySOAP &&
                                canUseIntegrations?.activeTlClearinghouse && (
                                    // canUseIntegrations?.activeSOAP &&
                                    <button
                                        className="check-eligibility-btn"
                                        onClick={(e) => {
                                            handleCheckEligibility(e);
                                        }}>
                                        {loadEligibility?.length ? (
                                            <MinLoader
                                                width={'18px'}
                                                height={'18px'}
                                                margin={'0'}
                                                color={'#0948A1'}
                                                position={'relative'}
                                            />
                                        ) : (
                                            <img src={Images.userCheckEligibility} alt="icon" />
                                        )}
                                        <p>Check Eligibility</p>
                                    </button>
                                )
                        }
                    </div>
                ),
            },
        {
            title: 'Last Modified',
            value:
                item?.editorFullName && item?.editedDate ? (
                    <div className="flex-align-center" style={{ gap: 4 }}>
                        <p>{item?.editorFullName ? `${item.editorFullName} - ` : ''}</p>
                        {/*{item?.editedDate ? <DateRow date={item?.editedDate} /> : ''}*/}
                        {item?.editedDate ? <LocalDateRow date={item?.editedDate} /> : ''}
                    </div>
                ) : (
                    '--'
                ),
        },

        // { title: 'Charge Rate', value: item?.chargeRateName ? item.chargeRateName : '--' },
        // {
        //     title: 'Last Modified Date',
        //     value: item?.editedDate ? <DateRow date={item?.editedDate} /> : '--',
        // },
        // { title: 'Hours', value: item?.hours ? item.hours : '--' },
        // { title: 'Hours', value: item?.hours ? item.hours?.toFixed(2) : '--' },
        // { title: 'Last Modified By', value: item?.editorFullName ? item.editorFullName : '--' },
        // { title: 'Created Date', value: item?.createdDate ? <DateRow date={item?.createdDate} /> : '--' },
        // { title: 'Created By', value: item?.creatorFullName ? item.creatorFullName : '--' },
    ];

    return (
        <div className="appt-detail-card-items">
            {serviceAppt?.map((i, j) =>
                i?.title && (
                    <Fragment key={j}>
                        <DetailItem background={i?.backgroundColor} title={i?.title} value={i?.value} />
                    </Fragment>
                )
            )}
        </div>
    );
};
